var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ADADAD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.5,5.8c-4.9-5.8-13.5-6.5-19.3-1.6c-3.7,3.1-5.5,7.9-4.7,12.7l0.9,5.3c1.2,7,7.8,11.7,14.7,10.5 c5.4-0.9,9.6-5.1,10.5-10.5l0.9-5.3C46.2,13,45.1,8.9,42.5,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.2,51.2l-1,5.3c-0.2,1.1-1,1.9-2,2.3C44.6,62.5,37.8,63,32,63h0c-5.8,0-12.6-0.5-23.2-4.1 c-1-0.4-1.8-1.2-2-2.3l-1-5.3c-1.1-5.9,2.8-11.6,8.7-12.8l2.7-0.5c2.5-0.5,4.5-2.3,5.3-4.7l0.4-1.3c5.4,4.2,12.9,4.2,18.3,0 l0.4,1.3c0.8,2.4,2.8,4.2,5.3,4.7l2.7,0.5C55.4,39.6,59.3,45.3,58.2,51.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.443b128e6eeec49dbc3c3c02b21a3ea4.svg";
export { ForwardRef as ReactComponent };